export const ResetStateActionType = 'authSlice/clearStore';
